<template>
    <div class="center_goods_sort_box">
        <!-- 搜索框 -->
        <div class="center_goods_search">
            <el-input
                size="mini"
                v-model="search"
                :placeholder="$t('message.ccoll.place')"
                @keyup.13.native="handelSearch(search)">
                <i slot="suffix" class="el-input__icon el-icon-search"></i>
            </el-input>
        </div>
        <!-- 排序方式-->
        <ul class="center_goods_sort clearfix">
            <li v-for="(item,index) in sort_list"
                :key="index" style="display: flex;align-items: center;">
                <el-button
                    type="text"
                    @click="handleSort(item.val,item.title)"
                    :class="{center_goods_sort_btn: item.val !== goodsSort}">
                    <span>{{item.title}}</span>	
					<i class="glyphicon glyphicon-arrow-down center_goods_sort_btn2"
					    v-show="'desc' == serial && item.val == goodsSort" ></i>
					<i class="glyphicon glyphicon-arrow-up center_goods_sort_btn2"
					    v-show="'asc' == serial  && item.val == goodsSort"></i>		
                </el-button>
				<!-- 图标 -->

				<!-- <i class="ico">
					<div  @click="handleSort(item.val,'asc')"  :class="serial=='asc' && item.val == goodsSort?'center_goods_sort_btn2':''"   class="el-icon-caret-top ico-bnt"></div>
					<div  @click="handleSort(item.val,'desc')" :class="serial=='desc' && item.val == goodsSort?'center_goods_sort_btn2':''" class="el-icon-caret-bottom ico-bnt"></div>
				</i> -->
            </li>
        </ul>
    </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
export default {
	props: [ "goodsSort", "serial" ],
    data() {
        return {
			name:'默認',
            search: '',
            sort_list: [
                {
                    title: this.$t("message.plist.sort1"),
                    val: ""
                },
                {
                    title: this.$t("message.plist.sort2"),
                    val:"b.virtual_sales"
                },
                {
                    title: this.$t("message.plist.sort3"),
                    val:"b.shop_price"
                },
                {
                    title: this.$t("message.plist.sort4"),
                    val:"b.createtime"
                }
            ],
        }
    },
    methods: {
		...mapActions([
		    "getsuccessively"
		]),
        handelSearch(value){
            this.$emit('handelSearch', value);
        },
        handleSort(value,name) {
			if(this.name == name){
				let successively = this.serial == 'asc'?'desc':'asc'
				this.getsuccessively(successively);	
				this.$emit('handleSort', value,successively);
			}else{
				this.$emit('handleSort', value,this.serial);	
			}
			this.name = name
        }
    },
}
</script>

<style scoped>
.ico{
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	margin-left: 10px;
	/* margin-left: 35px;
	margin-top: 8px; */
}
.ico-bnt{
	font-size: 10px;
	cursor:pointer;
	
}
/* 组件盒子 */
.center_goods_sort_box{
    width: 100%;
    margin-bottom: 10px;
    padding-bottom: 10px;
    border-bottom: 1px dashed #EBEEF5;
}
/* 搜索框 */
.center_goods_search{
    float: right;
    margin-right: 20px;
}
/* 排序方式列表 */
.center_goods_sort>li{
    float: left;
    padding: 0 40px;
    border-right: 1px solid #DCDFE6;
}
.center_goods_sort>li:last-child{
    border-right: 1px solid transparent;
}
/* 排序方式按钮基础颜色 */
.center_goods_sort_btn{
    color: #333;
}
.center_goods_sort_btn2{
	color: #FF6700;
}
</style>
